import React, { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { HelperText, TextInput, useTheme } from 'react-native-paper';
import PropTypes from 'prop-types';

import LocationSelectionMap from './LocationSelectionMap';
import DialogRadioButtonGroup from './inputs/DialogRadioButtonGroup';

import getStations from './map-assets/stations';
const stations = getStations();

function getStationName(stationKey) {
  const station = stations.find(({ key }) => key === stationKey);
  if (station) {
    return station.title;
  } else {
    return '';
  }
}

export default function LocationSelection({
  actions,
  appStyles,
  pageContent,
  toggleDisableNextStep,
}) {
  const {
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    touched,
    values,
    errors,
  } = actions;

  useEffect(() => {
    if (
      (errors.landAvailable && touched.landAvailable) ||
      !touched.landAvailable
    ) {
      toggleDisableNextStep(true);
    } else {
      toggleDisableNextStep(false);
    }
  }, [errors, touched]);

  const { colors } = useTheme();

  function updateSelectedStation(station) {
    setFieldValue('weatherStation', station);
    setFieldTouched('weatherStation', true);
  }

  function updateSelectedSoil(soil) {
    setFieldValue('soilCode', soil);
    setFieldTouched('soilCode', true);
  }

  return (
    <View style={styles.container}>
      <LocationSelectionMap
        stations={stations}
        updateSelectedStation={updateSelectedStation}
        updateSelectedSoil={updateSelectedSoil}
      />
      <Text>
        {pageContent[0]}: {getStationName(values.weatherStation)}
      </Text>
      <TextInput
        mode={'outlined'}
        style={styles.textInput}
        label={pageContent[1]}
        value={values.landAvailable}
        onChangeText={handleChange('landAvailable')}
        onBlur={handleBlur('landAvailable')}
        keyboardType="number-pad"
        error={touched.landAvailable && errors.landAvailable}
      />
      {touched.landAvailable && errors.landAvailable ? (
        <HelperText type="error" style={appStyles.helperTextError}>
          {errors.landAvailable}
        </HelperText>
      ) : null}
      <DialogRadioButtonGroup
        colors={colors}
        data={['ha', 'topos']}
        handleChange={handleChange}
        label={pageContent[2]}
        fieldName="landAvailableUnit"
        value={values.landAvailableUnit}
      />
      {touched.landAvailableUnit && errors.landAvailableUnit ? (
        <HelperText type="error" style={appStyles.helperTextError}>
          {errors.landAvailableUnit}
        </HelperText>
      ) : null}
    </View>
  );
}

LocationSelection.propTypes = {
  actions: PropTypes.shape({
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    touched: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object,
  }),
  appStyles: PropTypes.object,
  pageContent: PropTypes.array,
  toggleDisableNextStep: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  textInput: {
    marginTop: 15,
  },
});
